<template>
  <div class="edit">
    <div class="edit-content">
      <div class="edit-item">
        <div class="title">标题</div>
        <el-input v-model="editForm.label" placeholder="请输入内容"></el-input>
      </div>
      <div class="edit-item">
        <div class="title">提示文字</div>
        <el-input
          v-model="editForm.placeholder"
          placeholder="请输入内容"
        ></el-input>
      </div>
      <!-- <div class="edit-item">
        <div class="title">
          关联支付 <span>允许审批单完成后,为财务生成支付单,可在线支付</span>
        </div>
        <el-switch
          v-model="editForm.payment"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div> -->
      <div class="edit-item" @click="clickCounter">
        <div class="edit-count">计算公式={{ editForm.count }}</div>
      </div>
      <div class="edit-item">
        <div class="title">字段设为只读</div>
        <el-switch
          v-model="editForm.read"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="edit-item">
        <div class="title">显示大写 <span>(输入数字后自动显示大写)</span></div>
        <el-switch
          v-model="editForm.numberType"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="edit-item">
        <div class="title">是否必填</div>
        <el-switch
          @change="changeRequired"
          v-model="editForm.required"
          :active-value="1"
          :inactive-value="0"
          >必填
        </el-switch>
      </div>

      <div class="edit-item">
        <div class="title">
          参与打印
          <span>(如不勾选，打印时不显示该项)</span>
        </div>
        <el-switch v-model="editForm.pint" :active-value="1" :inactive-value="0"
          >参与打印
        </el-switch>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.$set(this.editForm, "count", " ");
  },
  methods: {
    batchClick() {
      this.$emit("batchClick");
    },
    addSelect() {
      this.$emit("addSelect");
    },
    removeSelect() {
      this.$emit("removeSelect");
    },
    clickCounter() {
      this.$emit("clickCounter");
    },
    // 是否必填
    changeRequired(val) {
      // console.log(val);
      // console.log(this.editForm);
      this.$emit("addRequired", this.editForm);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-count {
  padding: 10px 15px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}
.draggable-none {
  // margin: 42px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #999999;
  img {
    margin-right: 16px;
  }
}
.edit-none {
  height: 100%;
  color: #999999;
  position: relative;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.edit-number {
  width: 100%;
  line-height: 40px;
  background-color: #ffeeee;
  color: #d43030;
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
}
.edit-title {
  color: #0f66f2;
  margin-bottom: 24px;
  .iconfont {
    margin-right: 8px;
  }
}
.edit-column {
  text-align: center;
  margin: 35% 0 0;
  color: #999999;
  div {
    line-height: 36px;
  }
}
.addedit {
  padding: 12px 0;
  color: #0f66f2;
  span {
    padding: 0 8px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-right: 1px solid #eeeeee;
    }
  }
}
.edit-item {
  margin-bottom: 16px;
  .title {
    margin-bottom: 12px;
    span {
      font-size: 12px;
      color: #999;
    }
    i {
      font-style: normal;
      color: #0f66f2;
    }
  }
}
.edit-item2 {
  margin-bottom: 12px;
}
.edit-have {
  height: 100%;
}
.edit-item-list {
  margin-bottom: 8px;
}
.edit-ul {
  width: 80%;
  margin: 16px auto;
  li {
    display: flex;
    padding: 6px;
    border: 1px solid #eeeeee;
    div {
      width: 50%;
      text-align: center;
      &:nth-of-type(1) {
        border-right: 1px solid #eeeeee;
      }
    }
  }
}
</style>
